import { combineReducers } from 'redux';

import home from './reducers/home';
import customGeneral from './reducers/custom-general';
import customFilters from './reducers/custom-filters';
import customScheduler from './reducers/custom-scheduler';
import customSorts from './reducers/custom-sorts';
import selectedTime from './reducers/selected-time';
import selectedEvents from './reducers/selected-events';
import selectedEventsModal from './reducers/selected-events-modal';
import selectedOrganization from './reducers/selected-organization';
import selectedCurrency from './reducers/selected-currency';
import organizationSelect from '../../modules/organization-select/reducer.js';

const rootReducer = combineReducers({
  home,
  customGeneral,
  customFilters,
  customSorts,
  customScheduler,
  selectedEvents,
  selectedEventsModal,
  selectedTime,
  selectedOrganization,
  selectedCurrency,
  organizationSelect
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/modules/reports/reducers.js